<template>
  <div class="reader_left" :style="`height:${heightValue}px`">
    <div class="reader_left_top" v-if="bookInfo.bookName || bookInfo.writer">
      <div class="title" v-if="bookInfo.bookName">{{ bookInfo.bookName }}</div>
      <div class="author" v-if="bookInfo.writer">{{ bookInfo.writer }}</div>
    </div>
    <el-tabs v-model="activeName" type="card" class="reader_left_tabs">
      <el-tab-pane label="书内检索" name="inner" class="h-full">
        <InnerSearch @getSearch="getSearch" ref="innerSearch" :currentIndex="allCurrentIndex" @changePage="changePage">
        </InnerSearch>
      </el-tab-pane>
      <el-tab-pane label="所有页面" name="all" class="h-full">
        <AllPage :data="pageList" v-loading="loadingPage" @changePage="changePage" :currentIndex="allCurrentIndex"></AllPage>
      </el-tab-pane>
      <!-- disabled -->
      <el-tab-pane label="目录" name="catalog" class="h-full" :disabled="catalogDisabled">
        <span slot="label">
          <el-tooltip class="item" content="暂时没有目录数据" effect="light" placement="top" v-if="!catalogList.length">
            <span>目录</span>
          </el-tooltip>
          <span v-else>目录</span>
        </span>
        <Catalog @changePage="changePage" @getCatalog="getCatalog"></Catalog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InnerSearch from './innerSearch.vue'
import AllPage from './allPage.vue'
import Catalog from './catalog.vue'
import { getBookPageInfoApi } from '@/api/api'

export default {
  name: 'LeftBar',
  components: { InnerSearch, AllPage, Catalog },
  props: ['total', 'currentIndex', 'innerSearchStatus', 'bookInfo'],
  data () {
    return {
      heightValue: 0,
      activeName: 'catalog',
      pageList: [],
      catalogList: [],
      catalogDisabled: false,
      allCurrentIndex: 0,
      search: {},
      loadingPage:false
    }
  },
  mounted () {
    this.getPageList()
    const headerHeight = document.getElementsByClassName('header-bg')[0].offsetHeight
    const windowHeight = window.innerHeight
    this.heightValue = windowHeight - headerHeight
  },
  watch: {
    // total: {
    //   handler (val) {
    //     this.getPageList(val)
    //   }
    // },
    currentIndex: {
      handler (val) {
        this.allCurrentIndex = val
      },
      immediate: true
    },
    innerSearchStatus: {
      handler (val) {
        // val 1匹配到搜索内容，2未匹配到搜索内容
        this.$refs.innerSearch.setCurrentStatus(val)
      }
    },
    activeName: {
      handler (val) {
        // if (val === 'inner') {
        //   this.$refs.innerSearch.clearValue()
        // }
      }
    }
  },
  methods: {
    getSearch (val) {
      this.$emit('getSearch', val)
    },
    changePage (val) {
      this.$emit('changePage', val)
    },
    getPageList (data) {
      // if (data > 0) {
      // for (let i = 1; i <= data; i++) {
      //   this.pageList.push({
      //     label: `P${i}`,
      //     pageNum: i
      //   })
      // }
      try {
        let bookId = 0
        if (this.$route.query && this.$route.query.bookId) {
          bookId = this.$route.query.bookId
        }
        this.loadingPage=true
        getBookPageInfoApi({ bookId }).then(res => {
          this.loadingPage=false
          if(res.code==200){
            this.pageList = res.data
            this.$emit('getPageList', this.pageList)
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }

        })
      } catch (error) {
        this.loadingPage=false
        this.pageList = []
        this.$emit('getPageList', this.pageList)
      }
      // } else {
      //   this.pageList = []
      // }
    },
    getCatalog (data) {
      if (!data || !data.length) {
        if (this.$route.query && this.$route.query.search) {
          const search = JSON.parse(this.$route.query.search)
          // if (search.keyword) {
          //   this.activeName = 'inner'
          //   this.catalogDisabled = true
          // } else {
          this.activeName = 'all'
          this.catalogDisabled = true
          // }
        } else {
          this.activeName = 'all'
          this.catalogDisabled = true
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.reader_left {
  background-color: #FEFBF4;
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 300px;
  height:100%;
  border-radius: 4px;
  overflow: hidden;

  margin-right: 16px;
  // .h-full {
  //   height: 100%;
  // }
  .reader_left_top{
    border-radius: 4px;
    //background-color: rgba(255, 255, 255, 0.8);
    margin-bottom:16px;
    padding:16px 16px 16px 0;
    .title{
      position:relative;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #573E0D;
      line-height: 30px;
      padding-left:16px;
      margin-bottom: 12px;
     /* &:before{
        content:'';
        position: absolute;
        left: 0;
        top: 2px;
        width: 4px;
        height: 16px;
        background:#2C7E8D;
      }*/
    }
    .author{
      padding-left: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #2B2B2B;
    }
  }
  .reader_left_tabs{
    //background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    height: 100%;
    flex:1;
    flex-direction: column;
    overflow: hidden;
    /deep/ .el-tabs__nav-wrap{
      padding:0!important;
    }
    /deep/ .el-tabs__nav,/deep/ .el-tabs__header{
      //background:#f4f0e8;
      border:0;
      margin:0;
    }
    /deep/ .el-tabs__content{
      flex: 1;
      overflow: hidden;
    }
    /deep/ .el-tabs__nav-next,/deep/ .el-tabs__nav-prev{
      display: none;
    }
    /deep/ .el-tabs__item {
      padding: 0!important;
      width: 80px;
      height: 32px;
      line-height: 32px;
      text-align:center;
      border:0!important;
      color: #2B2B2B;
      font-size: 12px;
      font-weight: 400;
      background-color:#fff;
      border-radius: 4px 4px 0px 0px;
      &:nth-child(2) {
        margin:0 1px;
      }
      &.is-active{
        color: #DBB054;
        border:1px solid #DBB054;
        background-color: #fff;
        font-weight: 500;
      }
      &.is-disabled{
        color:#c0bcbc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/read/components/left.vue